// GENERATED by tools/hud-ui-audio/gen-amb-emitters.mjs from
// tools/src/t6-data-archive/MP/Mapents/mp_hijacked.d3dbsp (CoD space). Do not edit by hand.
// Started by clientscripts/mp/_audio.csc: startsoundloops / startlineemitters / startsoundrandoms.
export interface LoopEmitter { alias: string; origin: [number, number, number] }
export interface LineEmitter { alias: string; a: [number, number, number]; b: [number, number, number] }
export interface RandomEmitter { alias: string; origin: [number, number, number]; waitMin: number; waitMax: number }
export interface MapEmitters { loopers: LoopEmitter[]; lines: LineEmitter[]; randoms: RandomEmitter[] }

export const MAP_EMITTERS: Record<string, MapEmitters> = {
  mp_hijacked: {
    "loopers": [
      {
        "alias": "amb_main_engine",
        "origin": [
          -424,
          108,
          -99.5
        ]
      },
      {
        "alias": "amb_main_engine",
        "origin": [
          -143.75,
          107.75,
          -98.5
        ]
      },
      {
        "alias": "amb_water_flow_1",
        "origin": [
          -107.5,
          25.5,
          -47.5
        ]
      },
      {
        "alias": "amb_water_flow_1",
        "origin": [
          -78.25,
          203.25,
          -42.5
        ]
      },
      {
        "alias": "amb_water_flow_1",
        "origin": [
          -487,
          203,
          -51.5
        ]
      },
      {
        "alias": "amb_space_fan",
        "origin": [
          800.75,
          113.75,
          73.5
        ]
      },
      {
        "alias": "amb_space_fan",
        "origin": [
          1164,
          116,
          73.5
        ]
      },
      {
        "alias": "amb_space_fan",
        "origin": [
          1116.5,
          -214.25,
          208.5
        ]
      },
      {
        "alias": "amb_space_fan",
        "origin": [
          925.5,
          215.75,
          208.5
        ]
      },
      {
        "alias": "amb_space_fan",
        "origin": [
          -970.75,
          249.25,
          72.5
        ]
      },
      {
        "alias": "amb_space_fan",
        "origin": [
          -1219.75,
          -2,
          11.5
        ]
      },
      {
        "alias": "amb_space_fan",
        "origin": [
          -1079.75,
          132.25,
          216.5
        ]
      },
      {
        "alias": "amb_space_fan",
        "origin": [
          869.25,
          118.5,
          211.5
        ]
      },
      {
        "alias": "amb_cyber_screen",
        "origin": [
          875.5,
          15.25,
          242.5
        ]
      },
      {
        "alias": "amb_space_fan",
        "origin": [
          -1352.5,
          362.75,
          10.5
        ]
      },
      {
        "alias": "amb_shower_drain",
        "origin": [
          -213.5,
          5.5,
          21.5
        ]
      },
      {
        "alias": "amb_space_fan",
        "origin": [
          973.25,
          -358.75,
          74.5
        ]
      },
      {
        "alias": "amb_washing_mach",
        "origin": [
          -1476.25,
          246.75,
          -11.5
        ]
      },
      {
        "alias": "amb_random_vents",
        "origin": [
          -680.75,
          476,
          86
        ]
      },
      {
        "alias": "amb_random_vents",
        "origin": [
          -801.25,
          -451,
          75
        ]
      },
      {
        "alias": "amb_random_vents",
        "origin": [
          -1275.75,
          -586,
          11
        ]
      },
      {
        "alias": "amb_random_vents",
        "origin": [
          1304.25,
          465.5,
          75
        ]
      },
      {
        "alias": "amb_random_vents",
        "origin": [
          1293.75,
          -465,
          75
        ]
      },
      {
        "alias": "amb_random_vents",
        "origin": [
          325.25,
          -448.5,
          75
        ]
      }
    ],
    "lines": [
      {
        "alias": "amb_ocean_l",
        "a": [
          -3435.5,
          1374,
          833
        ],
        "b": [
          2644,
          1377,
          833
        ]
      },
      {
        "alias": "amb_ocean_r",
        "a": [
          -3339.5,
          -1410,
          833
        ],
        "b": [
          2740,
          -1407,
          833
        ]
      },
      {
        "alias": "amb_boat_creak_wake_l",
        "a": [
          -3435.5,
          844.75,
          192.25
        ],
        "b": [
          2644,
          847.75,
          192.25
        ]
      },
      {
        "alias": "amb_boat_creak_wake_r",
        "a": [
          -3368.25,
          -824.5,
          192.25
        ],
        "b": [
          2711.25,
          -821.5,
          192.25
        ]
      },
      {
        "alias": "amb_water_flow_1",
        "a": [
          -348.75,
          107.75,
          -70.75
        ],
        "b": [
          -191.75,
          106.25,
          -70.75
        ]
      },
      {
        "alias": "amb_water_flow_1",
        "a": [
          -84.5,
          -81.5,
          -56.75
        ],
        "b": [
          132.5,
          -83,
          -54.75
        ]
      },
      {
        "alias": "amb_engine_rm_dank",
        "a": [
          423.5,
          286.5,
          -1.75
        ],
        "b": [
          700.5,
          285,
          -2.75
        ]
      },
      {
        "alias": "amb_engine_rm_dank",
        "a": [
          -931.5,
          -94.5,
          -70.75
        ],
        "b": [
          -774.5,
          -96,
          -70.75
        ]
      },
      {
        "alias": "amb_engine_rm_dank",
        "a": [
          -1001.5,
          134,
          -67.75
        ],
        "b": [
          -994.5,
          -64.25,
          -70.75
        ]
      }
    ],
    "randoms": [
      {
        "alias": "amb_pool",
        "origin": [
          -2531.5,
          104.25,
          -69
        ],
        "waitMin": 3,
        "waitMax": 4
      },
      {
        "alias": "amb_pool",
        "origin": [
          -2525.75,
          -104,
          -69
        ],
        "waitMin": 5,
        "waitMax": 6
      },
      {
        "alias": "amb_pool",
        "origin": [
          -2754,
          -105,
          -69
        ],
        "waitMin": 3,
        "waitMax": 4
      },
      {
        "alias": "amb_pool",
        "origin": [
          -2851.75,
          118.75,
          -69
        ],
        "waitMin": 5,
        "waitMax": 7
      },
      {
        "alias": "amb_wind_whistle",
        "origin": [
          -1774.5,
          106.75,
          159
        ],
        "waitMin": 5,
        "waitMax": 10
      },
      {
        "alias": "amb_wind_whistle",
        "origin": [
          -1551.25,
          -337.5,
          192
        ],
        "waitMin": 8,
        "waitMax": 15
      },
      {
        "alias": "amb_wind_whistle",
        "origin": [
          -622,
          -56.75,
          274
        ],
        "waitMin": 8,
        "waitMax": 15
      },
      {
        "alias": "amb_wind_whistle",
        "origin": [
          335.25,
          226,
          287
        ],
        "waitMin": 8,
        "waitMax": 15
      },
      {
        "alias": "amb_wind_whistle",
        "origin": [
          1312.5,
          -11.25,
          263
        ],
        "waitMin": 8,
        "waitMax": 15
      },
      {
        "alias": "amb_comp_beeps",
        "origin": [
          1199.75,
          148.5,
          202
        ],
        "waitMin": 1,
        "waitMax": 2
      },
      {
        "alias": "amb_comp_beeps",
        "origin": [
          1200,
          -157.75,
          199
        ],
        "waitMin": 1,
        "waitMax": 2
      },
      {
        "alias": "amb_radar_ping",
        "origin": [
          1181.25,
          4,
          200
        ],
        "waitMin": 5,
        "waitMax": 10
      },
      {
        "alias": "amb_pool",
        "origin": [
          -3275.5,
          194.75,
          -271
        ],
        "waitMin": 10,
        "waitMax": 15
      },
      {
        "alias": "amb_pool",
        "origin": [
          -3298.25,
          -21.5,
          -285
        ],
        "waitMin": 9,
        "waitMax": 12
      },
      {
        "alias": "amb_pool",
        "origin": [
          -3247,
          -344.75,
          -275
        ],
        "waitMin": 5,
        "waitMax": 10
      },
      {
        "alias": "amb_pool",
        "origin": [
          -3523,
          -21.75,
          -258
        ],
        "waitMin": 9,
        "waitMax": 12
      }
    ]
  },
};
